import { Persona } from './persona'
import { Membership } from './membership'

export class PersonaMemberships {
  public persona: Persona

  public constructor(persona: Persona) {
    this.persona = persona
  }

  public get memberships(): Membership[] {
    return this.persona.memberships || []
  }

  public getValid(memdefId: string): Membership {
    const results: Membership[] = this.memberships
      .filter((membership: Membership) => {
        return membership.membership_definition.id === memdefId && membership.membershipStatus === 'valid'
      })
      .sort(this.sortByExpiresAt)
    return results.length ? results[0] : null
  }

  public hasValid(memdefId: string): boolean {
    if (this.memberships && this.memberships.length) {
      return this.memberships.some((membership: Membership) => {
        return membership.membership_definition.id === memdefId && membership.membershipStatus === 'valid'
      })
    }
    return false
  }

  public hasPending(memdefId: string): boolean {
    if (this.memberships && this.memberships.length) {
      return this.memberships.some((membership: Membership) => {
        return membership.membership_definition.id === memdefId && membership.membershipStatus === 'pending'
      })
    }
    return false
  }

  public hasRequested(memdefId: string): boolean {
    if (this.memberships && this.memberships.length) {
      return this.memberships.some((membership: Membership) => {
        return membership.membership_definition.id === memdefId
          && membership.membershipStatus === 'requested'
          && membership.affiliation_organization_id === null
      })
    }
    return false
  }

  public getPending(memdefId: string): Membership {
    const results: Membership[] = this.memberships
      .filter((membership: Membership) => {
        return membership.membership_definition.id === memdefId && membership.membershipStatus === 'pending'
      })
      .sort(this.sortByExpiresAt)
    return results.length ? results[0] : null
  }

  public getRequested(memdefId: string): Membership {
    const results: Membership[] = this.memberships
      .filter((membership: Membership) => {
        return membership.membership_definition.id === memdefId
          && membership.membershipStatus === 'requested'
          && membership.affiliation_organization_id === null
      })
      .sort(this.sortByExpiresAt)
    return results.length ? results[0] : null
  }

  public hasExpired(memdefId: string): boolean {
    if (!this.memberships || !this.memberships.length) return false
    return this.memberships.some((membership: Membership) => {
      return membership.membership_definition.id === memdefId && membership.membershipStatus === 'expired'
    })
  }

  public getExpired(memdefId: string): Membership {
    const results: Membership[] = this.memberships
      .filter((membership: Membership) => {
        return membership.membership_definition.id === memdefId && membership.membershipStatus === 'expired'
      })
      .sort(this.sortByExpiresAt)
    return results.length ? results[0] : null
  }

  public hasCanceled(memdefId: string): boolean {
    if (!this.memberships || !this.memberships.length) return false
    return this.memberships.some((membership: Membership) => {
      return membership.membership_definition.id === memdefId && membership.membershipStatus === 'canceled'
    })
  }

  public getCanceled(memdefId: string): Membership {
    const results: Membership[] = this.memberships
      .filter((membership: Membership) => {
        return membership.membership_definition.id === memdefId && membership.membershipStatus === 'canceled'
      })
      .sort(this.sortByExpiresAt)
    return results.length ? results[0] : null
  }

  public hasMembership(memdefId: string): boolean {
    if (this.memberships && this.memberships.length) {
      return this.memberships.some(
        (membership: Membership) => membership.membership_definition.id === memdefId
      )
    }
    return false
  }

  public isAffiliatedWithClub(memdefId: string, affiliationOrgId: number): boolean {
    if (this.memberships && this.memberships.length) {
      return this.memberships.some((membership: Membership) =>
        membership.membership_definition.id === memdefId && membership.affiliation_organization_id === affiliationOrgId
      )
    }
    return false
  }

  private sortByExpiresAt(a: Membership, b: Membership): number {
    return new Date(b.expires_at).getTime() - new Date(a.expires_at).getTime()
  }
}
